export default __webpack_public_path__ + "static/media/iconOk.754b4b0f.svg";